import React from 'react';
import { LoginPageStyle as S } from './LoginPage.style';
import { LoginPageBLoC as BLoC, useLoginPageBLoC } from './LoginPage.bloc';
import { LoginForm } from './components/LoginForm/LoginForm';
import { useObservableState } from 'observable-hooks';
import { LoginSSOProviders } from './components/LoginSSOProviders/LoginSSOProviders';
import { YabbleLogo } from 'components/YabbleLogo/YabbleLogo';

const LoginPageInner: React.FC = () => {
  const { $showMainLogin } = useLoginPageBLoC();
  const showMainLogin = useObservableState($showMainLogin);
  return showMainLogin ? <LoginForm /> : <LoginSSOProviders />;
};

const LoginPage: React.FC = () => {
  return (
    <BLoC>
      <S.Container>
        <S.BlueBox />
        <S.FormCard>
          <LoginPageInner />
        </S.FormCard>
        <S.LogoContainer>
          <a href="https://www.yabble.com/pricing.html">
            <YabbleLogo height={28} />
          </a>
        </S.LogoContainer>
      </S.Container>
    </BLoC>
  );
};

export default LoginPage;
